import siteInfo from "@/constants/siteInfo";
import Head from "next/head";

const NewsArticleSchema = ({
  title = "",
  description = "",
  keywords = "",
  canonical_url = "",
  image = "",
  publishedAt = "",
  modifiedAt = "",
  createdAt = "",
  authorName = "",
  authorCanonicalUrl = "",
  articleBody = "",
}) => {
  return (
    <Head>
      <script
        id="NewsArticleSchema"
        key="News_Article_Schema"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "NewsArticle",
            mainEntityOfPage:  canonical_url?.includes(
                process.env.NEXT_PUBLIC_WEBSITE_URL
              )
                ? `${canonical_url}`
                : process.env.NEXT_PUBLIC_WEBSITE_URL + `${canonical_url}`,
            
            headline: title,
            description: description,
            ...(keywords && { keywords: keywords }),
            image: {
              "@type": "ImageObject",
              height: 720,
              width: 1280,
              url: image +'?size=1280*720',
            },
            inLanguage: siteInfo.siteLanguage,
            datePublished: publishedAt,
            dateModified: modifiedAt,
            // dateCreated: createdAt,
            articleBody: articleBody || '',
            author: {
              "@type": "Person",
              name: authorName,
              url: authorCanonicalUrl?.includes(
                process.env.NEXT_PUBLIC_WEBSITE_URL
              )
                ? `${authorCanonicalUrl}`
                : process.env.NEXT_PUBLIC_WEBSITE_URL + `${authorCanonicalUrl}`,
            },
            publisher: {
              "@type": "Organization",
              name: siteInfo?.siteName,
              url: process.env.NEXT_PUBLIC_WEBSITE_URL,
              logo: {
                "@type": "ImageObject",
                url: `${siteInfo?.newSiteLogo}`,
                height: 60,
                width: 600,
              },
            },
          }),
        }}
      />
    </Head>
  );
};

export default NewsArticleSchema;
